import { PureComponent } from 'react';

import classNames from 'classnames';
import FormErrorMessage from 'components/FormErrorMessage';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import OverviewPropTypes from '../../../../OverviewPropTypes';
import menuTreeToMap from '../menuTreeToMap';
import Report from './Report';

const groupTarget = {
  drop(props, monitor) {
    const { onDragReport, reportsInGroup } = props;
    const { report } = monitor.getItem();
    const reportId = report.id;
    const findIndex = reportsInGroup.findIndex(
      (child) => child.id === reportId,
    );
    if (findIndex === -1) {
      onDragReport(reportId);
    }
  },
};

function dropCollect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  };
}

@DropTarget('treeViewReport', groupTarget, dropCollect)
export default class GroupsWidget extends PureComponent {
  static propTypes = {
    connectDropTarget: PropTypes.func.isRequired,
    data: PropTypes.array.isRequired,
    input: PropTypes.object.isRequired,
    isOver: PropTypes.bool.isRequired,
    meta: PropTypes.object.isRequired,
    msg: PropTypes.object.isRequired,
    onDeleteReportFromGroup: PropTypes.func.isRequired,
    onSortReport: PropTypes.func.isRequired,
    onWeightChange: PropTypes.func.isRequired,
    reports: OverviewPropTypes.reports,
    reportsInGroup: OverviewPropTypes.reportsInGroup,
  };

  getReports = (hasChildren, hasError) => {
    const {
      data,
      meta: { error },
      msg,
      onDeleteReportFromGroup,
      onSortReport,
      onWeightChange,
      reports,
      reportsInGroup,
    } = this.props;
    if (!hasChildren) {
      return (
        <div
          className={classNames(
            'dashboard-color-form__no-groups',
            hasError && 'dashboard-color-form__no-groups--error',
          )}
        >
          <div className='text-center'>
            <h4>{get(msg, 'dialog.groupSummary.dropHelp')}</h4>
            <p>{get(msg, 'dialog.groupSummary.dropHelp2')}</p>
            <img
              src='/public/img/dragdrop.png'
              alt={get(msg, ['dialog', 'groupSummary', 'dropColorRule'])}
              width='190px'
              height='115px'
            />
          </div>
        </div>
      );
    }
    const treeMap = hasChildren && menuTreeToMap(data, {}, []);
    const weightError = error?.split('-')[1];
    const errors = weightError?.split(',');
    return (
      <table className='table-condensed mb-2 table'>
        <thead>
          <tr>
            <th className='dashboard-color-form__groups-th'>
              {get(msg, ['dialog', 'groupSummary', 'colorRule'])}
            </th>
            <th
              className='dashboard-color-form__groups-th'
              style={{ width: '80px' }}
            >
              {get(msg, ['dialog', 'groupSummary', 'weight'])}
            </th>
            <th
              className='dashboard-color-form__groups-th'
              style={{ width: '80px' }}
            />
          </tr>
        </thead>
        <tbody>
          {hasChildren ? (
            reportsInGroup.map((child, childIndex) => {
              const childId = child.id;
              const foundReport = reports.find((r) => r.id === childId);
              const path = treeMap[foundReport.webEndpoint];
              if (foundReport) {
                return (
                  <Report
                    key={childId}
                    child={child}
                    childId={childId}
                    childIndex={childIndex}
                    errors={errors}
                    foundReport={foundReport}
                    onDeleteReportFromGroup={onDeleteReportFromGroup}
                    onSortReport={onSortReport}
                    onWeightChange={onWeightChange}
                    path={path}
                    reportsInGroup={reportsInGroup}
                  />
                );
              }
              return null;
            })
          ) : (
            <tr>
              <td colSpan='3'>
                {get(msg, ['dialog', 'groupSummary', 'noReportsAddReports'])}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  };

  render() {
    const {
      connectDropTarget,
      isOver,
      reportsInGroup,
      meta: { touched, error },
      msg,
    } = this.props;
    const hasChildren = reportsInGroup.length;
    const hasError = touched && error;
    return connectDropTarget(
      <div>
        <div
          className={classNames(
            'dashboard-color-form__group-wrapper',
            isOver && 'dashboard-color-form__group-wrapper--over',
            hasChildren && 'dashboard-color-form__group-wrapper--children',
          )}
        >
          {this.getReports(hasChildren, hasError)}
        </div>
        {hasError ? (
          <FormErrorMessage>
            {msg.validation[error.split('-')[0]]}
          </FormErrorMessage>
        ) : null}
      </div>,
    );
  }
}
